import { render, staticRenderFns } from "./EstablishmentsList.vue?vue&type=template&id=2a83b126&scoped=true&"
import script from "./EstablishmentsList.vue?vue&type=script&lang=js&"
export * from "./EstablishmentsList.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentsList.vue?vue&type=style&index=0&id=2a83b126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83b126",
  null
  
)

export default component.exports